module.exports = __webpack_public_path__ + "img/logo_industry.f517ebda.png";